module.exports = __webpack_public_path__ + "img/worksbot_img19112535.af9d7c91.jpg";